import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

function initUpgradePage() {
  if (($('#controller-account.action-upgrade').length === 0) && ($('#controller-account.action-plan').length === 0)) { return; }

  // Payment form setup (Stripe tokenization) is handled by payment-form Stimulus controller

  if ($('form.payment').hasClass('legacy')) {

    // Legacy plan

    // Scheme selector handler
    $('.interval-choice .radio input').on('click', function () {
      $('.interval-choice').removeClass('selected');
      $(this).closest('.interval-choice').addClass('selected');
      adjust_summary_legacy();
      return adjust_savings_legacy();
    });

    // Interval choices selector handler
    $('.interval-choice .radio input').on('click', function () {
      $('.interval-choice').removeClass('selected');
      $(this).closest('.interval-choice').addClass('selected');
      adjust_interval_choices_legacy();
      adjust_summary_legacy();
      return adjust_savings_legacy();
    });

    // Initially adjust interval choices display
    adjust_interval_choices_legacy();
    adjust_summary_legacy();
    adjust_savings_legacy();

  } else {

    // New unlimited plan

    // Scheme choices selector handler
    $('.interval-choice .radio input').on('click', function () {
      $('.interval-choice').removeClass('selected');
      $(this).closest('.interval-choice').addClass('selected');
      // $('.interval-choice .description').hide()
      // $(this).closest('.interval-choice').find('.description').show()
      return adjust_summary();
    });

    // Initially adjust scheme summary
    adjust_summary();

    // Overage branding selector handler
    return $('.overage-branding-choice .radio input').on('click', function () {
      $('.overage-branding-choice').removeClass('selected');
      return $(this).closest('.overage-branding-choice').addClass('selected');
    });
  }
}

// Run on initial load and on Turbo navigation (plan/upgrade pages reached via Turbo won't have payment form setup otherwise)
$(function () { initUpgradePage(); });
document.addEventListener('turbo:load', initUpgradePage);
// $('.overage-branding-choice .description').hide()
// $(this).closest('.overage-branding-choice').find('.description').show()

var adjust_summary = function () {
  const title = $('.interval-choice .radio input:checked').data('title');
  const total = $('.interval-choice .radio input:checked').data('total');
  $('.payment-summary-title').text(title);
  return $('.payment-summary-total').text(`$${total}`);
};

var adjust_interval_choices_legacy = function () {
  if ($('.interval-choice .radio input:checked').val() === "1M") {
    $('.scheme-interval-1y').hide();
    $('.scheme-interval-1m').find(`input[data-name-1m=${$('.scheme-interval-1y input:checked').data('name-1m')}]`).click();
    return $('.scheme-interval-1m').show();
  } else {
    $('.scheme-interval-1m').hide();
    $('.scheme-interval-1y').find(`input[data-name-1y=${$('.scheme-interval-1m input:checked').data('name-1y')}]`).click();
    return $('.scheme-interval-1y').show();
  }
};

var adjust_summary_legacy = function () {
  $('.payment-summary-scheme').text($('.interval-choice .radio input:checked').closest('.interval-choice').find('.title-and-price .scheme-title').text());
  if ($('.interval-choice .radio input:checked').val() === "1M") {
    $('.payment-summary-interval').text("paid monthly");
  } else {
    $('.payment-summary-interval').text("paid yearly");
  }
  return $('.payment-summary-total').text($('.interval-choice .radio input:checked').closest('.interval-choice').find('.title-and-price .scheme-price').text());
};

var adjust_savings_legacy = () => $('.yearly-savings').text(`$${$('.interval-choice .radio input:checked').data('savings-1y').toFixed(2)}`);
